export const AccessControlReport = {
  selectedCamerasAreNotSetUp:
    "Las cámaras seleccionadas no están configuradas para detectar entradas y/o salidas.",
  pleaseSelectAReport: "Por favor, selecciona un reporte.",
  pleaseAddOneOrMoreAssets: "Por favor, agregue uno o más assets.",
  noReportsHaveBeenCreated: "No hay reportes creados.",
  maximumImagesPerHour: "Máximo de imágenes por hora",
  detectionType: "Tipo de detección",
  detectionTypeOptions: {
    entry: "Entrada",
    exit: "Salida",
    both: "Entrada y salida",
  },
  changes: "Cambios",
  showingDetections: (value: number | string, total: number | string) =>
    `Mostrando ${value} de ${total} detecciones.`,
};
